import appPick from "./pick-list";

export default angular.module("app.component", [appPick]).name;
